// ============================================
// Radmoto Free Bag Auto-Add
// Adds storage bag to cart when a qualifying
// bike is added. Uses Shopify AJAX Cart API.
// ============================================

(function () {
  // Qualifying bike product IDs
  const QUALIFYING_PRODUCT_IDS = [
    9449439920433, 9823893684529, 10048174391601, 10048181862705,
    10048196247857, 10052380918065, 10100086145329, 10100157645105,
    10267144618289, 10371866820913, 10372747624753, 10373799838001,
    10534419726641, 10635188863281, 10642309742897, 10642332614961,
    10699275665713, 10747496694065
  ];

  // Storage bag variant ID
  const BAG_VARIANT_ID = 50298690535729;

  // Check if bag is already in cart, then add if not
  async function addBagIfNotPresent() {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    const alreadyInCart = cart.items.some(item => item.variant_id === BAG_VARIANT_ID);
    if (alreadyInCart) return;

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: BAG_VARIANT_ID, quantity: 1 })
    });
  }

  // Intercept fetch-based add-to-cart (AJAX themes)
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';

    if (url.includes('/cart/add')) {
      try {
        const clone = response.clone();
        const data = await clone.json();
        const items = Array.isArray(data.items) ? data.items : [data];
        const hasQualifyingBike = items.some(item =>
          QUALIFYING_PRODUCT_IDS.includes(item.product_id)
        );
        if (hasQualifyingBike) addBagIfNotPresent();
      } catch (e) {}
    }
    return response;
  };

  // Intercept form-based add-to-cart (non-AJAX themes)
  document.addEventListener('submit', async function (e) {
    const form = e.target;
    if (!form.matches('form[action="/cart/add"]')) return;

    const productIdInput = form.querySelector('[name="id"]');
    if (!productIdInput) return;

    const variantId = productIdInput.value;
    try {
      const res = await fetch(`/variants/${variantId}.js`);
      const variant = await res.json();
      if (QUALIFYING_PRODUCT_IDS.includes(variant.product_id)) {
        setTimeout(addBagIfNotPresent, 1000);
      }
    } catch (e) {}
  });
})();
